import React from 'react';
import cn from 'classnames';
import appearAnimationClasses from 'swag-client-common/components/ecommerce-header/appear.anim.scss';
import { CSSTransition } from 'react-transition-group';
import FilterControllers from './components/filter-controllers';
import classes from './filters-row-panel.scss';
const FiltersRowPanel = ({
  filter,
  isFilterOpened,
  isSubcategoriesExist = false,
  isSearch,
  total,
  onDeleteActiveFilter,
  onClearFilters,
  isCategoriesSticky,
  isAllSwagHovered,
  shouldShowFiltersPanel = false
}) => {
  const filterKeys = Object.keys(filter).sort(key => key === 'categoryId' ? -1 : 1);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: Boolean(filterKeys.length) && isCategoriesSticky && (isFilterOpened || shouldShowFiltersPanel),
    timeout: 255,
    classNames: appearAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.activeFilterContainerWrapper, {
      [classes.isAllSwagHoveredWrapper]: isAllSwagHovered
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.activeFilterContainer, {
      [classes.isAllSwagHoveredContainer]: isAllSwagHovered,
      [classes.closedFilter]: !isFilterOpened,
      [classes.additionalMargin]: isSubcategoriesExist && !isFilterOpened
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.container, {
      [classes.searchContainer]: isSearch,
      [classes.openSearchContainer]: isFilterOpened && isSearch
    })
  }, /*#__PURE__*/React.createElement(FilterControllers, {
    filter: filter,
    onDeleteActiveFilter: onDeleteActiveFilter,
    onClearFilters: onClearFilters,
    classNames: classes.chipContainer
  })), total !== 0 && !isSearch && /*#__PURE__*/React.createElement("span", {
    className: cn(classes.link),
    "data-text": "ProductsCounts"
  }, total, " product", total !== 1 && 's' || ''))));
};
export default FiltersRowPanel;